import { render } from "./Tour.vue?vue&type=template&id=31ef1c97"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import "./Tour.vue?vue&type=style&index=0&id=31ef1c97&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__